module.exports = __webpack_public_path__ + "static/img/genesis-showroom.f691a89.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/genesis-showroom.jpg
// module id = BYkA
// module chunks = 0